module.exports = "/packs/media/images/cash-money-c2e4a1c58e334307b2fd3b4ff0da542f.png";